// extracted by mini-css-extract-plugin
export default {"root":"Agent__root--XnuDx","image":"Agent__image--FDMiR","details":"Agent__details--ViH_E","name":"Agent__name--QULLo","phone":"Agent__phone--xvTlO","email":"Agent__email--TEQor"};